var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
          'btn--hovered' : _vm.isHovered && !_vm.$store.state.isMobile,
          'btn--bordered' : _vm.bordered,
          'btn--small' : _vm.small,
          'btn--behance' : _vm.isFromBehance
        },on:{"click":function($event){return _vm.$emit('click')},"mouseenter":_vm.mouseIn,"mouseleave":_vm.mouseOut}},[_c('span',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),(!_vm.$store.state.isMobile)?_c('span',{staticClass:"btn__hover"},[_c('span',{staticClass:"btn__label-wrapper"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }